// extracted by mini-css-extract-plugin
module.exports = {"truckCard":"FleetCard_truckCard__jhIiW","truck-img":"FleetCard_truck-img__bcqOt","truck-type":"FleetCard_truck-type__3lsCA"};